import { render, staticRenderFns } from "./FeedInfo.vue?vue&type=template&id=044a8cbf&scoped=true"
import script from "./FeedInfo.vue?vue&type=script&lang=js"
export * from "./FeedInfo.vue?vue&type=script&lang=js"
import style1 from "./FeedInfo.vue?vue&type=style&index=1&id=044a8cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a8cbf",
  null
  
)

export default component.exports